
// src/utils/SessionTimeoutManager.js
class SessionTimeoutManager {
    constructor(timeout = 30 * 60 * 1000, onTimeout) { // Default 30 minutes
        this.timeout = timeout;
        this.onTimeout = onTimeout;
        this.timer = null;
        this.resetTimer = this.resetTimer.bind(this);
    }

    start() {
        // Add event listeners to detect user activity
        window.addEventListener('mousemove', this.resetTimer);
        window.addEventListener('mousedown', this.resetTimer);
        window.addEventListener('keypress', this.resetTimer);
        window.addEventListener('scroll', this.resetTimer);
        window.addEventListener('touchstart', this.resetTimer);

        // Start the initial timer
        this.resetTimer();
    }

    stop() {
        // Clear timeout and remove event listeners
        this.clearTimer();
        window.removeEventListener('mousemove', this.resetTimer);
        window.removeEventListener('mousedown', this.resetTimer);
        window.removeEventListener('keypress', this.resetTimer);
        window.removeEventListener('scroll', this.resetTimer);
        window.removeEventListener('touchstart', this.resetTimer);
    }

    resetTimer() {
        this.clearTimer();
        this.timer = setTimeout(() => {
            this.onTimeout();
        }, this.timeout);
    }

    clearTimer() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
}

export default SessionTimeoutManager;
